module.exports = __webpack_public_path__ + "static/media/logo.6437eb3c.png";